// Reglas del formulario de garantía (alta y edición), aparte para poder probarlas.

// Valor estimado: solo córdobas enteros, como antes.
export const esValorEscribible = (valor) => /^[0-9]*$/.test(valor);

/**
 * Errores por campo; objeto vacío si se puede guardar.
 * @param {object} datos { articulo, color, valorEstimado, fotos (nuevas), fotosActuales }
 */
export const validarGarantia = ({ articulo, color, valorEstimado, fotos = [], fotosActuales = 0 }) => {
  const errores = {};
  if (!articulo || articulo.trim() === "") errores.articulo = "Escriba el artículo";
  if (!color || color.trim() === "") errores.color = "Escriba el color";
  if (valorEstimado === "" || valorEstimado === undefined || Number(valorEstimado) <= 0) {
    errores.valorEstimado = "Escriba el valor estimado";
  }
  if (fotos.length === 0 && fotosActuales === 0) errores.fotos = "Elija al menos una foto";
  return errores;
};

/**
 * Formulario que se envía. Marca, modelo y serie vacíos van como S/M, S/M y S/S. Antes el alta
 * agregaba ese valor como un segundo campo y el servidor se quedaba con el primero (vacío).
 * Las fotos van como `garantiaPhotos`, el nombre que espera el servidor (la edición mandaba
 * `garantiaPhoto` y nunca llegaban).
 */
export const formularioGarantia = ({ id, creditId, articulo, marca, color, modelo, serie, valorEstimado, fotos = [] }) => {
  const formData = new FormData();
  if (id) formData.append("id", id);
  if (creditId) formData.append("creditId", creditId);
  formData.append("articulo", articulo.trim());
  formData.append("marca", marca.trim() || "S/M");
  formData.append("color", color.trim());
  formData.append("modelo", modelo.trim() || "S/M");
  formData.append("serie", serie.trim() || "S/S");
  formData.append("valorEstimado", valorEstimado);
  fotos.forEach((foto) => formData.append("garantiaPhotos", foto));
  return formData;
};
